module.exports = __webpack_public_path__ + "static/media/十周年_2@2x.6cb98285.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_210/images/十周年_2@2x.png
// module id = 1753
// module chunks = 0